import { create } from "zustand";
import { ProjectTaskDashboard } from "../../../interfaces/Projects/projectTaskDashboard";
import { useTaskStatesStore } from "../TaskStates/TaskStatesStore";
import { TaskState } from "../../../interfaces/Projects/Catalogs/taskStates";


interface ProjectTaskDashboardStore {
    projectTasks: ProjectTaskDashboard[];
    isTaskCompleted: Record<number, boolean>; // Mapa de task_id => boolean (true si está completada)
    setProjectTasks: (by: ProjectTaskDashboard[]) => void;
    addProjectTask: (by: ProjectTaskDashboard) => void;
    updateProjectTask: (by: ProjectTaskDashboard) => void;
    deleteProjectTask: (by:number) => void;
    setIsTaskCompleted: (taskId: number, completed: boolean) => void;
    checkIfTaskIsCompleted: (task: ProjectTaskDashboard) => boolean;
}

export const useProjectTaskDashboardStore = create<ProjectTaskDashboardStore>()(
    (set, get) => ({
        projectTasks: [],
        isTaskCompleted: {}, 
        setProjectTasks: (by: ProjectTaskDashboard[]) => {

            const isTaskCompleted = by.reduce((acc, task)=>{
                if(task.project_task_id){
                    acc[task.project_task_id] = get().checkIfTaskIsCompleted(task);
                }
                
                return acc;
            }, {} as Record<number,boolean>)

            set({ projectTasks: by, isTaskCompleted });
        },
        addProjectTask: (by: ProjectTaskDashboard) => {
            set((state) => ({ projectTasks: [...state.projectTasks, by] }))
        },
        updateProjectTask: (by: ProjectTaskDashboard) => {
            set((state) => ({
                projectTasks: state.projectTasks.map((projectTask) =>
                    projectTask.project_task_id === by.project_task_id ? by : projectTask
                ),
            }));
        },
        deleteProjectTask: (by: number) =>{
            set((state)=> ({
                projectTasks: state.projectTasks.filter((projectTask) => projectTask.project_task_id != by)
            }))
        },
        setIsTaskCompleted:(taskId: number, completed: boolean)=>{
            set((state)=>({
                isTaskCompleted :{
                    ...state.isTaskCompleted,
                    [taskId]: completed
                },
            }))
        },
        checkIfTaskIsCompleted: (task: ProjectTaskDashboard) => {
            const { taskStates } = useTaskStatesStore.getState(); 
            const currentState = taskStates.find(
                (state: TaskState) => state.task_state_id === task.current_task_state_id
            );
            return currentState ? currentState.task_state_name === "DONE" : false;
        },
    })
)